module.exports = __webpack_public_path__ + "static/media/icon_136.36545560.svg";